import ApiClient from './ApiClient';
/* global axios */

class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }

  // Override de tablero (Victor 2026-06-10): branchId opcional para traer las
  // etapas de OTRA sucursal sin cambiar la sucursal logeada (chip en Leads).
  show(id, branchId = null) {
    const params = branchId ? { branch_id: branchId } : {};
    return axios.get(`${this.url}/${id}`, { params });
  }
}

export default new PipelinesAPI();
